import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatDialog } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import Project from 'models/project/project.model';
import TicketAttribute from 'models/ticket-attribute/ticket-attribute.model';
import { CreateTicketAttributeComponent } from 'modules/ticket-attribute/create-ticket-attribute/create-ticket-attribute.component';
import { ProjectService } from 'services/project/project.service';
import { TicketAttributeService } from 'services/ticket-attribute/ticket-attribute.service';

@Component({
  selector: 'app-list-ticket-attribute',
  templateUrl: './list-ticket-attribute.component.html',
  styleUrls: ['./list-ticket-attribute.component.scss'],
})
export class ListTicketAttributeComponent implements OnInit, OnDestroy {
  @Input() public project: Project;
  public ticketAttributes: TicketAttribute[] = [];

  private ticketAttributeSubscription: Subscription;

  constructor(
    public projectService: ProjectService,
    public ticketAttributeService: TicketAttributeService,
    public snackBar: MatSnackBar,
    public router: Router,
    private dialog: MatDialog,
  ) { }

  ngOnInit() {
    this.ticketAttributeService.selectList(this.project);
    this.ticketAttributeSubscription = this.ticketAttributeService.getSelectedList().subscribe((ticketAttributes) => this.ticketAttributes = ticketAttributes);
  }

  create() {
    this.router.navigate(['/ticketattribute/create'], { queryParams: { project: this.project.id } });
  }

  async del(item: TicketAttribute) {
    if (await this.ticketAttributeService.delete(item)) {
      this.snackBar.open('Törlés sikeres.', '', {
        duration: 2000,
      });
    }
    this.ticketAttributeService.selectList(this.project);
  }

  openModal(item?: TicketAttribute, isArcgis?: boolean) {
    this.dialog.open(
      CreateTicketAttributeComponent,
      {
        minWidth: '350px',
        data: { item, project: this.project, isArcgis: isArcgis || (item && item.auto) },
        panelClass: 'attribute-panel',
      },
    );
  }

  ngOnDestroy() {
    if (this.ticketAttributeSubscription) {
      this.ticketAttributeSubscription.unsubscribe();
    }
  }
}
